import CloseIcon from "@assets/svg/CloseIcon";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogTitle,
} from "@components/ui/dialog";
import { Dispatch, SetStateAction } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@store/reducers";
import dayjs from "@lib/dayjs";

interface RefundModalProps {
  openModal: boolean;
  setOpenModal: Dispatch<SetStateAction<boolean>>;
}

const RefundModal = ({ openModal, setOpenModal }: RefundModalProps) => {
  const navigate = useNavigate();
  const { jobDetail } = useSelector((state: RootState) => state?.job);
  
  return (
    <Dialog open={openModal} onOpenChange={setOpenModal}>
      <DialogContent showCloseButton={false} className="bg-white">
        <DialogClose asChild>
          <button
            onClick={() => {
              setOpenModal(false);
            }}
            className="h-max ml-auto rounded-md hover:bg-gray-50"
          >
            <CloseIcon className={"w-5 h-5"} />
          </button>
        </DialogClose>
        <DialogTitle className="text-xl text-center !font-normal">
          Eligible refund of job posting fee due to unsuccessful placement{" "}
        </DialogTitle>
        <div className="flex flex-col items-center gap-4 my-8">
          <div className="flex w-64">
            <span className="font-medium text-xs w-32">Reference:</span>
            <span className="font-medium text-xs flex-1">
              {jobDetail?.refNo}
            </span>
          </div>
          <div className="flex w-64">
            <span className="font-medium text-xs w-32">Title:</span>
            <span className="font-medium text-xs flex-1">
              {jobDetail?.title}
            </span>
          </div>
          <div className="flex w-64">
            <span className="font-medium text-xs w-32">Job post date:</span>
            <span className="font-medium text-xs flex-1">
              {jobDetail?.refNo}
            </span>
          </div>
          <div className="flex w-64">
            <span className="font-medium text-xs w-32">Job close date:</span>
            <span className="font-medium text-xs flex-1">
              {dayjs().format("DD MMM YYYY")}
            </span>
          </div>
        </div>
        <DialogFooter>
          <div className="flex flex-col items-center w-full gap-2">
            <button
              onClick={() =>
                navigate("/transactions/refunds/refund-summary", {
                  state: jobDetail,
                })
              }
              className="font-medium text-sm bg-[#ECECEC] text-charcoal py-2 px-10 rounded-md flex items-center hover:bg-gray-200"
            >
              Click here to process refund
            </button>
            <button
              onClick={() => navigate("/job")}
              className="font-medium text-sm text-light-black py-1.5 px-5 rounded-md flex items-center hover:text-gray-800"
            >
              Process refund later
            </button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
export default RefundModal;
